<script lang="ts" setup>   
    import '../../css/choice.css';
    import {onMounted,reactive,watch} from 'vue';
    import {GetMedGuideline,IMedInformationInput,IMedGuideline,medInformationType,guidLineType,printClass,no_drug_information,errorReturnMessage} from '../lib/Models/InteractionModel'; 

    const formData = reactive <
    {   
        medRetrieved: boolean, 
        type: medInformationType, 
        guidelineList? : IMedGuideline[],
        noData: boolean,
        medErrorMessage? : string
    }>
    ({     
        medRetrieved : false, 
        type: medInformationType.PatientGuidelines, 
        noData: true,
        medErrorMessage: ""
    });
    onMounted(() => { 
        formData.type = (props.type === guidLineType.Patient ? medInformationType.PatientGuidelines : medInformationType.ProviderGuidelines); 
    });
     
    const props = withDefaults( defineProps<
        {
            showDialog: boolean, 
            type: guidLineType,
            patientID: number,
            prescriptionID?: number,
            medicationID?: number,
            displayHeight? : number 
        }>(),
        {
            showDialog: false, 
            patientID: 0,
            prescriptionID: 0,
            medicationID: 0,
            displayHeight : 350
        });

    watch(() => props.showDialog, (newShow,oldShow) => { 
        if ((newShow) && (newShow !== oldShow) && (!formData.medRetrieved)) { 
            getGuideline();
        }
    }); 
    const emit=defineEmits(["updateModalGuidline"]);  

    async function getGuideline() : Promise<void> {   
        const medInputs : IMedInformationInput = {InformationType: formData.type,PatientID: props.patientID, PrescriptionID: props.prescriptionID, MedID: props.medicationID};
        const respGet = await GetMedGuideline(medInputs);  
        
        if (!respGet.success) {  
            formData.medErrorMessage = respGet.error?.error ?? errorReturnMessage.guidelines; 
            return;
        }
        formData.noData = (respGet.success.guidelineList.length === 0 ? true : false);
        formData.medRetrieved = true; 
        formData.guidelineList = respGet.success.guidelineList; 
        if (formData.guidelineList.length > 0) {
            const report_data = 
                `<div style="${[printClass.recordTitle]}">${guidLineType[props.type]} Guidelines</div>` +
                "<ol>" + formData.guidelineList.map(item => "<li>" + item.monograph + "</li>").join("") + "</ol>";
            emit('updateModalGuidline', true, props.type, report_data);  
        } 
    } 
</script>

<template> 
    <div class="row pt-2"> 
        <div v-if="formData.medErrorMessage" class="col"> 
            {{ formData.medErrorMessage }}
        </div>
        <div v-if="!formData.medErrorMessage" class="col"> 
            <div class="row"> 
                <div class="fw-bold fs-6 text-isalus-primary pb-2 ">
                    {{guidLineType[props.type]}} Guidelines
                </div>
            </div>
            <div class="row"> 
                <div class="col skinnyscroll " :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': (props.displayHeight + 'px')}"> 
                    <div v-if="formData.noData" class="text-muted"> 
                        {{no_drug_information}}
                    </div>
                    <ol id="guidelines" v-if="!formData.noData" > 
                        <div v-if="!formData.noData" v-for="guidlineRecord in formData.guidelineList"> 
                            <li class="text-muted"> 
                                {{guidlineRecord.monograph}}
                            </li>
                        </div>  
                    </ol>  
                </div>
            </div>
        </div>
    </div>
</template>